import {
  EditorWrapper,
  type EditorWrapperHandle,
} from '@/features/Templates/components/EditorWrapper'
import { NBSP } from '@/utils'
import { Box, Code, Field, VStack } from '@chakra-ui/react'
import React, { forwardRef, useImperativeHandle, useRef } from 'react'

export interface NewClusterStep3OverridesHandle {
  focus: () => void
}

export const NewClusterStep3Overrides = forwardRef<
  NewClusterStep3OverridesHandle,
  {
    overrideYaml: string
    onChange: (value: string | undefined) => void
    shouldFocus?: boolean
  }
>(({ overrideYaml, onChange, shouldFocus }, ref) => {
  const editorRef = useRef<EditorWrapperHandle>(null)

  useImperativeHandle(ref, () => ({
    focus: () => {
      editorRef.current?.focus()
    },
  }))

  // Focus the editor when shouldFocus prop is true
  React.useEffect(() => {
    if (shouldFocus && editorRef.current) {
      setTimeout(() => {
        editorRef.current?.focus()
      }, 0)
    }
  }, [shouldFocus])
  return (
    <VStack data-testid="step-overrides" gap={6} alignItems="start" w="100%">
      <Field.Root w="100%">
        <Field.Label w={36} display="inline-flex">
          Overrides
          <Box as="span" fontWeight={400} color="text.text-subtle" ml={2}>
            (Optional)
          </Box>
        </Field.Label>
        <Field.HelperText mb={2}>
          This section must be written in valid YAML format and is used to
          override variables defined in the template.
          <br />
          For example, if your template includes a variable like{NBSP}
          <Code>[=OVERRIDE_CUSTOMER_PIZZACHOICE]</Code>, you can override it
          using the format shown in the placeholder.
        </Field.HelperText>
        <EditorWrapper
          id="overrides-editor"
          ref={editorRef}
          minHeight={300}
          maxHeight={300}
          placeholder={['customer:', '  pizzachoice: hawaian']}
          yamlContent={overrideYaml}
          onChange={onChange}
        />
      </Field.Root>
    </VStack>
  )
})
